import React from 'react';

const ChartIcon = ({ className = "", size = "lg" }) => {
  // تحديد الحجم بناءً على المعلمة size
  const sizeMap = {
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
    xl: "w-24 h-24",
    "2xl": "w-32 h-32"
  };

  const sizeClass = sizeMap[size] || sizeMap.lg;

  return (
    <div className={`${sizeClass} ${className}`}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        <rect width="24" height="24" rx="12" className="fill-current text-blue-100" />
        
        {/* الإطار الخارجي */}
        <rect x="4" y="4" width="16" height="16" rx="2" className="fill-current text-white" />
        
        {/* رسم الخطوط والأعمدة */}
        <path d="M4 16H20" stroke="currentColor" strokeWidth="0.5" strokeDasharray="1 1" />
        <path d="M4 12H20" stroke="currentColor" strokeWidth="0.5" strokeDasharray="1 1" />
        <path d="M4 8H20" stroke="currentColor" strokeWidth="0.5" strokeDasharray="1 1" />
        
        {/* أعمدة الرسم البياني */}
        <rect x="6" y="16" width="2" height="3" className="fill-current text-blue-500" />
        <rect x="9" y="13" width="2" height="6" className="fill-current text-blue-600" />
        <rect x="12" y="10" width="2" height="9" className="fill-current text-blue-700" />
        <rect x="15" y="7" width="2" height="12" className="fill-current text-blue-800" />
        
        {/* خط الرسم البياني */}
        <path
          d="M5 13.5L8 11L11 13L14 9L17 6.5"
          stroke="#F59E0B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* نقاط على الخط */}
        <circle cx="5" cy="13.5" r="1" fill="#F59E0B" />
        <circle cx="8" cy="11" r="1" fill="#F59E0B" />
        <circle cx="11" cy="13" r="1" fill="#F59E0B" />
        <circle cx="14" cy="9" r="1" fill="#F59E0B" />
        <circle cx="17" cy="6.5" r="1" fill="#F59E0B" />
      </svg>
    </div>
  );
};

export default ChartIcon;